import { forwardRef } from 'react';
import type { InputHTMLAttributes } from 'react';
import styled from 'styled-components';

type CheckboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

const CheckboxInput = styled.input.attrs({ type: 'checkbox' })`
  appearance: none;
  display: inline-grid;
  place-content: center;
  width: 1.25rem;
  height: 1.25rem;
  margin: 0;
  padding: 0;
  flex-shrink: 0;
  cursor: pointer;
  border: 0.0625rem solid ${({ theme }) => theme.semantic.neutrals_600};
  border-radius: ${({ theme: { spacing } }) => spacing(1.5)};
  background: transparent;
  vertical-align: middle;

  &:checked,
  &:indeterminate {
    border-color: ${({ theme }) => theme.semantic.accent_500};
    background: ${({ theme }) => theme.semantic.accent_500};
  }

  &:checked::after {
    content: '';
    width: 0.3125rem;
    height: 0.5625rem;
    margin-top: -0.125rem;
    border: solid ${({ theme }) => theme.semantic.content_primary_button};
    border-width: 0 0.125rem 0.125rem 0;
    transform: rotate(45deg);
  }

  &:indeterminate::after {
    content: '';
    width: 0.625rem;
    height: 0.125rem;
    background: ${({ theme }) => theme.semantic.content_primary_button};
  }

  &:focus-visible {
    outline: ${({ theme: { spacing } }) => spacing(0.5)} solid ${({ theme }) => theme.semantic.accent_500};
    outline-offset: ${({ theme: { spacing } }) => spacing(0.5)};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>((props, ref) => (
  <CheckboxInput ref={ref} {...props} />
));

Checkbox.displayName = 'Checkbox';

export default Checkbox;
